'use client'

import { useParams } from 'next/navigation'
import { useProductQuery } from '@/generated/graphql'
import { ContentWrapper } from '@/General/ContentWrapper'
import { H1 } from '@/General/H1'
import { Breadcrumb } from '@/General/Breadcrumb'
import { LoadingSpinner } from '@/General/LoadingSpinner'
import { AuthCheck } from '../AuthCheck'

export function ProductData() {
  const params = useParams<{ productSlug: string }>()

  // Note: Community questions are global (not brand-specific), so we default to US brand
  // for product metadata. Questions are shared across all brands.
  const { data: productData, isLoading: isProductLoading } = useProductQuery({
    slug: params.productSlug,
    brandCode: 'VANISHING_INC_US',
  })

  const productName = productData?.ecommProductBySlug?.name || 'this product'

  const pages = [
    {
      name: productName,
      href: `/product/${params.productSlug}`,
    },
    { name: 'Ask a Question', href: '#' },
  ]

  if (isProductLoading) {
    return (
      <ContentWrapper>
        <div className="flex justify-center py-8">
          <LoadingSpinner />
        </div>
      </ContentWrapper>
    )
  }

  if (!productData?.ecommProductBySlug) {
    return (
      <ContentWrapper>
        <div className="text-center py-8">
          <p>Product not found.</p>
        </div>
      </ContentWrapper>
    )
  }

  return (
    <ContentWrapper>
      <H1>Ask the community about {productName}</H1>
      <Breadcrumb pages={pages} className="mb-4" />

      <AuthCheck
        productId={productData.ecommProductBySlug.id}
        productSlug={params.productSlug}
        productName={productName}
      />
    </ContentWrapper>
  )
}
